import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchSalesOdersByDate, voidSalesOrder, fetchSalesOrders, fetchSalesOrderDetail,
  selectSalesOrder, resetCurrentSalesOrder, setSalesOrdersFilter, setValue, loadsPost,
  printShippingList, printYingBOL, printReceivingReport, printYingCustomerFile, removeSalesOrderPDF, printSalesOrder, printPickingList, printPickingListATL,
  printPickingListAFG, printPackingList, printPackingListATL, printShippingListATL, orderToQuote, quoteToOrder, printSalesOrderLabel, printSalesOrderLabelBOL, printSalesOrderLabelDSQ,
  printSalesOrderLabelBatch, createMobileTask, updateShippingWeight, updateShippingWeightSplit, emailSO,
  fetchShippingWeightTracking, fetchJmlTracking, reshipOrder, setQuoteOrder, updateVoidNote, chowbusImport, submitBolImage,
  printBolById, setOrderToOpen,
  printBolWithoutLog, printBolByFba, printBolLabel, fetchBolAddress, printShippigLabel, setDavisPO, printSalesOrderLabelUSPride, reprintSalesOrderLabelUSPride,
  selectTeapplixShipping, printTeapplixLabel, deleteTeapplixShipping,
} from '../../actions/sales_actions';
import { fetchSalesOrdersByFilter, searchInvoicesByInvoiceNo, searchInvoicesByTrackingNo,
  setOrdersToOpen, uploadSOImage, uploadSOPOD } from '../../actions/salesOrderList_actions';
import { setDefaultDays, setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { fetchProductSuggestions } from '../../actions/autoSuggest_actions';
import { fetchBaseUsers, checkPassword, clearCheckPassword } from '../../actions/settings_actions';
import { fetchCustomers } from '../../actions/customers_actions';

import SalesOrders from '../../components/Sales/salesOrders';

const salesOrders = reduxForm({
  form: 'salesOrders',
  destroyOnUnmount: false,
})(SalesOrders);

const selector = formValueSelector('salesOrders');

function mapStateToProps(state) {
  const Days = selector(state, 'Days');
  const FromDate = selector(state, 'FromDate');
  const ToDate = selector(state, 'ToDate');
  const Status = selector(state, 'Status');
  const Seller = selector(state, 'Seller');
  const ProductNum = selector(state, 'ProductNum');
  return {
    Days,
    FromDate,
    ToDate,
    Status,
    Seller,
    ProductNum,
    currentSalesOrder: state.salesOrders.currentSalesOrder,
    salesOrders: state.salesOrders.all,
    isLoading: state.salesOrders.isLoading,
    error: state.salesOrders.error,
    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
    salesOrderIsLoading: state.salesOrders.detailIsLoading,
    salesOrderError: state.salesOrders.detailError,
    salesOrdersFilter: state.salesOrders.salesOrdersFilter,
    userPermissions: state.auth.userPermissions,
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,
    msoTotalPages: state.salesOrders.msoTotalPages,

    requestingShippingList: state.salesOrders.requestingShippingList,
    shippingListPDF: state.salesOrders.shippingListPDF,

    requestingPickingList: state.salesOrders.requestingPickingList,
    pickingListPDF: state.salesOrders.pickingListPDF,

    requestingPackingList: state.salesOrders.requestingPackingList,
    packingListPDF: state.salesOrders.packingListPDF,

    requestingSalesOrderPDF: state.salesOrders.requestingSalesOrderPDF,
    salesOrderPDF: state.salesOrders.salesOrderPDF,

    requestingBolIdPDF: state.salesOrders.requestingBolIdPDF,
    bolIdPDF: state.salesOrders.bolIdPDF,
    requestingBolWithoutLogPDF: state.salesOrders.requestingBolWithoutLogPDF,
    bolWithoutLogPDF: state.salesOrders.bolWithoutLogPDF,
    requestingBolLabel: state.salesOrders.requestingBolLabel,
    bolLabel: state.salesOrders.bolLabel,
    requestingBolFbaPDF: state.salesOrders.requestingBolFbaPDF,
    bolFbaPDF: state.salesOrders.bolFbaPDF,
    bolAddress: state.salesOrders.bolAddress,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,

    quoteLoading: state.salesOrders.quoteLoading,

    customers: state.customers.all,
  };
}

export default connect(mapStateToProps, {
  setDefaultDays,
  fetchSalesOdersByDate,
  voidSalesOrder,
  fetchSalesOrders,
  fetchSalesOrderDetail,
  selectSalesOrder,
  resetCurrentSalesOrder,
  loadsPost,
  setSalesOrdersFilter,
  setValue,
  fetchBaseUsers,
  setDefaultOfForm,
  fetchSalesOrdersByFilter,
  printShippingList,
  printYingBOL,
  printReceivingReport,
  printYingCustomerFile,
  removeSalesOrderPDF,
  printSalesOrder,
  printPickingList,
  printPickingListAFG,
  printPickingListATL,
  printPackingList,
  printPackingListATL,
  printShippingListATL,
  fetchProductSuggestions,
  checkPassword,
  clearCheckPassword,
  orderToQuote,
  quoteToOrder,
  printShippigLabel,
  printSalesOrderLabel,
  printSalesOrderLabelBOL,
  printSalesOrderLabelDSQ,
  printSalesOrderLabelBatch,
  createMobileTask,
  emailSO,
  updateShippingWeight,
  updateShippingWeightSplit,
  fetchShippingWeightTracking,
  fetchJmlTracking,
  searchInvoicesByInvoiceNo,
  searchInvoicesByTrackingNo,
  reshipOrder,
  setQuoteOrder,
  updateVoidNote,
  chowbusImport,
  submitBolImage,
  printBolById,
  printBolWithoutLog,
  printBolLabel,
  printBolByFba,
  fetchBolAddress,
  fetchCustomers,
  setDavisPO,
  printSalesOrderLabelUSPride,
  reprintSalesOrderLabelUSPride,
  setOrdersToOpen,
  uploadSOImage,
  uploadSOPOD,
  setOrderToOpen,
  selectTeapplixShipping,
  printTeapplixLabel,
  deleteTeapplixShipping,
})(salesOrders);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesOrders.jsx